(function () {
    "use strict";

    angular.module("virtualFairs")
        .controller("VirtualFairHostsFormController", VirtualFairHostsFormController);

    VirtualFairHostsFormController.$inject = ["VirtualFairService", "InvoicesService", "virtualfair", "toastr", "$state", "$scope"];

    function VirtualFairHostsFormController(VirtualFairService, InvoicesService, virtualfair, toastr, $state, $scope) {

        var vm = this;

        vm.addExistingHost = addExistingHost;
        vm.openHostsSelect = false;
        vm.selectedHost = null;
        vm.selectedHostData = null;

        vm.selectExistingHost = selectExistingHost;

        vm.addNewHost = addNewHost;

        vm.saveHost = saveHost;
        vm.addHostCancel = addHostCancel;

        vm.openHostFields = false;

        vm.highSchoolNames = [{ value: '' }];
        vm.addNameHighSchoolCounselor = addNameHighSchoolCounselor;
        vm.removeNameHighSchoolCounselor = removeNameHighSchoolCounselor;

        vm.listAddedHosts = listAddedHosts;
        vm.editAddedHost = editAddedHost;
        vm.removeAddedHost = removeAddedHost;

        vm.uploadFile = uploadFile;

        vm.location = null;


        vm.selectExpoTypes = selectExpoTypes;
        vm.selectServiceRegions = selectServiceRegions;
        vm.getTitle = getTitle;
        vm.addExpoSession = addExpoSession;
        vm.mountVirtualFair = mountVirtualFair;
        vm.goToList = goToList;
        vm.selectProfileTypes = selectProfileTypes;
        vm.title = "Create Virtual Event"
        vm.logoPreview = '';
        vm.flag = true;
        vm.selectPavilionThumb = selectPavilionThumb;

        vm.logicOptions = [
            { id: 0, name: 'No' },
            { id: 1, name: 'Yes' }
        ];


        vm.dateOptions = {
            autoUpdateInput: true,
            autoApply: true,
            singleDatePicker: true,
            showTimepicker: false,
            locale: {
                format: "DD/MM/YYYY",
                cancelLabel: "Close"
            },
        };

        vm.dateTimeOptions = {
            autoUpdateInput: true,
            autoApply: true,
            singleDatePicker: true,
            showTimepicker: true,
            locale: {
                format: "DD/MM/YYYY HH:MM",
                cancelLabel: "Close"
            },
        };

        async function editAddedHost(host) {
            vm.selectedHost = host.id;
            await selectExistingHost();
        }

        async function listAddedHosts() {
            await VirtualFairService.getAddedHosts(vm.virtualfair.id).then(function (response) {
                console.log(response)
                vm.addedHosts = response.data;
            })
        }

        function addNameHighSchoolCounselor() {
            vm.highSchoolNames.push({value : ''});
        }

        function removeNameHighSchoolCounselor(field) {
            vm.highSchoolNames.splice(vm.highSchoolNames.indexOf(field), 1);
        }

        async function addExistingHost() {
            await VirtualFairService.getHosts().then(function (response) {
                vm.hosts = response.data;
                console.log(response.data)
            })

            vm.openHostsSelect = true;
        }

        function addNewHost() {
            vm.selectedHost = null;
            vm.selectedHostData = null;
            vm.host = null;

            vm.highSchoolNames = [{ value: '' }];

            vm.openHostFields = true
        }

        async function removeAddedHost(virtualFairHost) {

            alertify
                .confirm('Do you really remove the host?')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancel'
                })
                .set('title', 'Alert!')
                .set('onok', async function (){
                    await VirtualFairService.removeHost(virtualFairHost.id).then(function (response) {
                        console.log(response)
                    });
        
                    await vm.listAddedHosts();        
                })
                .show();
        }

        async function saveHost() {
            vm.host['high_school_counselor_names'] = JSON.stringify(vm.highSchoolNames.map( h => h.value ))
            vm.host['virtual_fair_id'] = vm.virtualfair.id;
            vm.host['file'] = vm.file ? vm.file : '';

            if (vm.location && vm.location.place_id) {
                const stateInfo = vm.location.address_components.filter(comp => comp.types.includes('administrative_area_level_1'));
                
                vm.host['place_id'] = vm.location.place_id;
                vm.host['city'] = vm.location.vicinity;
                vm.host['state'] = stateInfo.length > 0 ?
                    stateInfo[0].short_name :
                    '';
                vm.host['countries_id'] = vm.location.address_components.filter(comp => comp.types.includes('country'))[0].short_name;    
            }

            if (vm.selectedHost) {
                await VirtualFairService.updateHost(vm.host, vm.selectedHost).then(function (response) {
                    console.log(response)
                })
            } else {
                await VirtualFairService.storeHost(vm.host).then(function (response) {
                    console.log(response)
                })
            }

            vm.listAddedHosts();
            vm.selectedHost = null;
            vm.selectedHostData = null;
            vm.host = null;

            vm.highSchoolNames = [{ value: '' }];

            vm.openHostFields = false
        }

        function addHostCancel() {
            vm.openHostsSelect = false;
        }

        function uploadFile(event) {
            let file = event.target.files[0];
            let reader = new FileReader();
            reader.onload = function (event) {
                $scope.$apply(function () {
                    vm.file = event.target.result;
                });
            };
            reader.readAsDataURL(file);
        }

        async function selectExistingHost() {
            console.log('Select Existing host ', vm.selectedHost)
            await VirtualFairService.getHostsById(vm.selectedHost).then(function (response) {
                vm.selectedHostData = response.data.host;
                vm.host = vm.selectedHostData

                vm.host.students_expect_apply_college = parseInt(vm.selectedHostData.students_expect_apply_college);
                vm.host.students_high_school_have = parseInt(vm.selectedHostData.students_high_school_have);
                vm.host.students_high_school_expect = parseInt(vm.selectedHostData.students_high_school_expect);

                if (vm.host.countries_id) {
                    vm.location = `${vm.host.city}, ${vm.host.state}, ${vm.host.countries_id}`;
                }

                vm.highSchoolNames = [{ value: '' }];
                if (vm.selectedHostData.high_school_counselor_names) {
                    vm.highSchoolNames = [];
                    JSON.parse(vm.selectedHostData.high_school_counselor_names).map( h => {
                        vm.highSchoolNames.push({ value: h });
                    });    
                }

                vm.openHostFields = true
            })
        }

        async function selectExpoTypes() {
            await VirtualFairService.getExpoTypes().then(function (response) {
                vm.expotypes = response.data;
            })
        }

        async function selectServiceRegions() {
            await VirtualFairService.getServiceRegions().then(function (response) {
                vm.serviceRegions = response.data;
            });
        }

        async function getTitle() {
            if (vm.virtualfair) {
                vm.title = "Edit Virtual Event"
            }
            return await vm.title;
        }

        async function selectPavilionThumb(pavilion, thumb, pavIndex) {
            if (typeof vm.virtualfair.pavilions === 'object' && vm.virtualfair.pavilions.length > 0) {
                vm.virtualfair.pavilions = vm.virtualfair.pavilions.map((pav, idx) => {
                    if(idx === pavIndex){
                        return {
                            ...pav,
                            image: thumb.image,
                            style: thumb.style
                        }
                    }
                    return pav
                });
            }
            console.log(vm.virtualfair.pavilions)
            return await vm.virtualfair.pavilions;
        }

        async function addExpoSession(session = null) {
            vm.virtualfair.sessions.push({
                id: session ? session.id : null,
                expo_date: session ? session.expo_date : null,
                start_datetime_utc: session ? session.start_datetime_utc : null,
                end_datetime_utc: session ? session.end_datetime_utc : null,
                time_your_city: session ? session.time_your_city : null
            });
            return await vm.virtualfair.sessions;
        }

        async function mountVirtualFair() {
            vm.virtualfair = {
                id: null,
                name: "",
                title: "",
                expo_type_id: "",
                is_workshop: "",
                is_high_school: "",
                has_networking_event: "",
                target_region: "",
                target_students: "",
                target_exhibitors: "",
                booths_limit: "",
                description: "",
                logistics_url: "",
                school_profile_url: "",
                service_regions: [],
                pavilions: [],
                sessions: [],
                early_bird_datetime_utc: "",
                registration_deadline: "",
                booth_setup_deadline: "",
                student_registration_deadline: "",
                scheduling_deadline: "",
                currency: "",
                cost_center: "",
                early_bird_rate: 0.00,
                rate: 0.00,
                logistics_pdf: "",
                image: "",
                school_profiles_pdf: "",
                description_event_ics: "",
                description_booth_setup_ics: "",
                max_representatives: "",
                event_group_id: "",
                profile_types: [],
                platform_system: 1,
                calendar_id: "",
                room_free_limit: 2,
                room_rate: 500,
                room_max_visitors: 20,
                exhibitors_survey_url: "",
            };
            if (virtualfair) {
                vm.virtualfair.id = virtualfair.id;
                vm.virtualfair.image_url = virtualfair.image_url;
                vm.virtualfair.name = virtualfair.name;
                vm.virtualfair.title = virtualfair.title;
                let expo_type = vm.expotypes.filter(item => item.id == virtualfair.expo_type_id);
                if (expo_type.length) {
                    vm.virtualfair.expo_type_id = expo_type[0].id;
                }
                vm.virtualfair.description = virtualfair.description;
                virtualfair.sessions.filter(function (session) {
                    vm.addExpoSession(session)
                });
                vm.virtualfair.early_bird_datetime_utc = virtualfair.early_bird_datetime_utc;
            }
        }

        async function goToList() {
            return await $state.go('root.virtualfair.settings');
        }

        async function selectProfileTypes() {
            VirtualFairService.getProfileTypes().then(function (response) {
                vm.profileTypes = response.data;
                // vm.expos.unshift({id: -1, name: '--- All ---'});
            });
        }


        async function activate() {
            await vm.selectExpoTypes();
            await vm.selectServiceRegions();
            await vm.selectProfileTypes();
            await vm.getTitle();


            await vm.mountVirtualFair();
            await vm.listAddedHosts()
        }

        activate();
    }
})();